export enum PaymentMethodStatus {
  verified = 'verified',
  unverified = 'unverified',
  failed = 'failed',
}
